import React, { useState, useEffect } from 'react';
import { history } from '../../history/history';

import mapData from '../../util/mapCityData';
const Map = props => {

  useEffect(() => {
    showMap();
    props.renderCard(true)
  }, [props.w])

  //Redirect to package bassed on location.
  const getLocation = event => {
    history.push({ pathname: '/package', state: { lat: event.point.lat, lon: event.point.lon, city: event.point.fullName } });
  }

  //Show the map at home page.
  const showMap = () => {
    return (
      <div> {Highcharts.mapChart('map_india', {

        chart: {
          map: 'countries/in/custom/in-all-disputed',
          width: props.w,
          height: props.w,
          backgroundColor: 'rgba(255, 255, 255, 0)',
        },

        title: {
          text: '',

        },

        plotOptions: {
          series: {
            // enableMouseTracking: false,
            stickyTracking: false,
            events: {
              click: function (e) {
                getLocation(e);

              }
            }
          },
          // stickyTracking: false,
        },
        mapNavigation: {
          enabled: false
        },

        credits: {
          enabled: false
        },

        exporting: {
          enabled: false
        },

        tooltip: {
          headerFormat: '',
          pointFormat: '<b>{point.fullName}</b>',
          //  followPointer: true,
          style: {
            opacity: 0.9
          },
          backgroundColor: '#f9d10c'
        },

        series: [{
          name: 'Basemap',
          // animation: { duration: 3000 },
          borderColor: '#4f4575',
          cursor: 'pointer',
          showInLegend: false,
          nullColor: 'rgb(255,255,255)'

        },
        {
          type: 'mappoint',
          name: '',
          color: '#4f4575',
          animation: { duration: 6000 },

          marker: {
            symbol: 'url(../../assets/images/Ripple.svg)',
            enabled: true,
            radius: 1,
            states: {
              hover: {
                enabled: true,
                animation: {
                  duration: 100
                },
                lineWidthPlus: 10,
                lineColor: 'rgba(247, 163, 92, .5)',
                radiusPlus: 2
              }
            }
          },
          maxSize: '12%',
          data: mapData
        }]
      })}</div>
    )
  }


  return (
    <div id="map_india"></div>
  )
}

export default Map;


// WEBPACK FOOTER //
// ./web/components/home/Map.jsx